<script>
import {

  redirectToHome
} from "../../../../helpers/routerHelper";

export default {
  name: "StepHeader",
  data() {
    return {
      isSignedIn: false,
    };
  },
  methods: {
    handleBeforeUnload(event) {
      if (this.$route.path !== "/uconnect/register/confirm") {
        event.preventDefault();
        event.returnValue = "Are you sure you want to leave without saving?";
        this.clearUserDetails();
      }
    },
    toHome() {
      //clear search text from session storage

      if (this.$route.path === "/uconnect/register/confirm") {
        this.$router.push("/");
       this.clearUserDetails();
      }else {

        this.$confirm('Are you sure you want to cancel your registration? Any data you\'ve entered so far will not be saved.', '', {
          confirmButtonText: 'Confirm', confirmButtonClass: 'confirm-class', cancelButtonClass: 'cancel-class'
        })
          .then(_ => {
            var that = this;
            this.clearUserDetails();
            if (that.$route.path !== "/") {
              this.$router.push("/");
            } else {
              that.reload();
            }
          })
          .catch(_ => { });
      }
    },
    clearUserDetails() {
      this.$store.commit("uConnect/clearUserDetails");
      localStorage.removeItem("uConnectRegistrationKey");
    }
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
};
</script>

<template>
  <el-header class="header-outer-wrapper" >
    <el-row>
      <el-col :span="12" class="left-centered">
        <img
          src="../../../../assets/unifi-logo-new-with-text-green.svg"
          style="width: 250px; height: 42px"
          @click="toHome"
        />
      </el-col>
      <el-col :span="12" class="right-centered">
        <img src="../../../../assets/menu-alt-new.svg"
             style="height: 50px"
             @click="$emit('spread')" />
      </el-col>
    </el-row>
  </el-header>
</template>

<style lang="scss" scoped>
.header-outer-wrapper {
  background-color: #ffffff;
  padding: 0;
  height: 80px !important;
}
.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 16px 16px 0;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 0 16px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/steps/stepsHeader.vue